import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top on every route change so navigating from a long
 * listing page to the cart / dashboard doesn't leave the user halfway down.
 * Rendered once inside the router below all Providers.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        try { window.scrollTo({ top: 0, behavior: "instant" }); }
        catch { window.scrollTo(0, 0); }
    }, [pathname]);
    return null;
}
